'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationRvHookup = function NotificationRvHookup(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 17v-6c0-1.1-.9-2-2-2H7V7l-3 3 3 3v-2h4v3H4v3c0 1.1.9 2 2 2h2c0 1.66 1.34 3 3 3s3-1.34 3-3h8v-2h-2zm-9 3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm7-6h-4v-3h4v3zM17 2v2H9v2h8v2l3-3z' })
  );
};
NotificationRvHookup = (0, _pure2.default)(NotificationRvHookup);
NotificationRvHookup.displayName = 'NotificationRvHookup';
NotificationRvHookup.muiName = 'SvgIcon';

exports.default = NotificationRvHookup;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/svg-icons/notification/rv-hookup.js
 ** module id = 2300
 ** module chunks = 0
 **/